import { ScreenMode } from 'feature/screenMode'
import { RouterProvider } from 'react-router-dom'
import { router } from 'router/router'
import { CookieConsent } from 'widget/CookieConsent'

function App() {
  return (
    <>
      <ScreenMode />
      <CookieConsent />
      <RouterProvider router={router} />
    </>
  )
}

export default App
